import { Objective } from "protos/rtc/jobs";
import { ObjectivesSelectionList } from "./ObjectiveSelectionList";
import React, { FC } from "react";

interface ObjectivePanelProps {
  objectives: Objective[];
}
export const ObjectivePanel: FC<ObjectivePanelProps> = ({ objectives }) => {
  return (
    <div>
      <ObjectivesSelectionList objectives={objectives} />
    </div>
  );
};
